module.exports = __webpack_public_path__ + "img/shift-logs.543afe38.svg";